import { Link } from 'react-router-dom'
import './Home.css'

const Home = () => {
  const clientList = [
    { name: 'Acer', logo: './images/acer.png' },
    { name: 'HPE', logo: './images/hpe.png' },
    { name: 'PeopleLink', logo: './images/peoplelink.png' },
    { name: 'Molex', logo: './images/molex.png' },
    { name: 'D-Link', logo: './images/dlink.png' },
    { name: 'Techroutes', logo: './images/techroutes.png' },
    { name: 'Aruba', logo: './images/aruba.png' },
    { name: 'Systrome', logo: './images/systrome.png' },
    { name: 'Matrix', logo: './images/matrix.png' },
    { name: 'Vantageo', logo: './images/vantageo.png' },
    { name: 'Fortinet', logo: './images/fortinet.png' },
    { name: 'Vertiv', logo: './images/vertivlogo.png' },
    { name: 'hp', logo: './images/hp.png' },
  ]

  return (
    <div className='home'>
      {/* Hero Section */}
      <section className='hero'>
        <div className='hero-background'>
          <img
            src='https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80'
            alt='Hero Background'
          />
          <div className='hero-overlay'></div>
        </div>
        <div className='hero-container'>
          <div className='hero-content'>
            <h1 className='hero-title'>
              Accelerate Your Digital Transformation
            </h1>
            <p className='hero-subtitle'>
              TecMates Infocom delivers end-to-end technology solutions that
              empower organizations to achieve smarter operations, seamless
              connectivity, and long-term technology resilience.
            </p>
            <div className='hero-buttons'>
              <Link to='/services' className='btn btn-primary'>
                Explore Services
              </Link>
              <Link to='/contact' className='btn btn-secondary'>
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className='services-overview'>
        <div className='container'>
          <h2 className='section-title'>Our Core Services</h2>
          <p className='section-subtitle'>
            Comprehensive IT solutions designed to meet your unique business
            needs
          </p>

          <div className='services-grid'>
            <div className='service-card'>
              <div className='service-icon'>
                <i className='fas fa-server'></i>
              </div>
              <h3>IT Infrastructure</h3>
              <p>
                Desktops, laptops, servers, workstations & storage solutions for
                reliable performance.
              </p>
              <Link to='/services#infrastructure' className='service-link'>
                Learn More
              </Link>
            </div>

            <div className='service-card'>
              <div className='service-icon'>
                <i className='fas fa-network-wired'></i>
              </div>
              <h3>Networking</h3>
              <p>
                SD-WAN, enterprise LAN/WAN design & wireless network solutions.
              </p>
              <Link to='/services#networking' className='service-link'>
                Learn More
              </Link>
            </div>

            <div className='service-card'>
              <div className='service-icon'>
                <i className='fas fa-shield-alt'></i>
              </div>
              <h3>Cybersecurity</h3>
              <p>
                Next-gen firewall, endpoint security & comprehensive threat
                protection.
              </p>
              <Link to='/services#security' className='service-link'>
                Learn More
              </Link>
            </div>

            <div className='service-card'>
              <div className='service-icon'>
                <i className='fas fa-cloud'></i>
              </div>
              <h3>Cloud Solutions</h3>
              <p>
                Cloud migration, virtualization & disaster recovery solutions.
              </p>
              <Link to='/services#cloud' className='service-link'>
                Learn More
              </Link>
            </div>

            <div className='service-card'>
              <div className='service-icon'>
                <i className='fas fa-video'></i>
              </div>
              <h3>Collaboration</h3>
              <p>
                Video conferencing, unified communication & digital signage
                solutions.
              </p>
              <Link to='/services#collaboration' className='service-link'>
                Learn More
              </Link>
            </div>

            <div className='service-card'>
              <div className='service-icon'>
                <i className='fas fa-tools'></i>
              </div>
              <h3>Managed Services</h3>
              <p>AMC contracts, remote support & IT helpdesk services.</p>
              <Link to='/services#managed' className='service-link'>
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Showcase */}
      <section className='technology-showcase'>
        <div className='container'>
          <h2 className='section-title'>Cutting-Edge Technology</h2>
          <p className='section-subtitle'>
            State-of-the-art infrastructure and solutions
          </p>
          <div className='showcase-grid'>
            <div className='showcase-item'>
              <img
                src='https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
                alt='Data Center'
              />
              <h3>Data Center Solutions</h3>
              <p>
                Enterprise-grade infrastructure for mission-critical operations
              </p>
            </div>
            <div className='showcase-item'>
              <img
                src='https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
                alt='Network Security'
              />
              <h3>Network Security</h3>
              <p>Advanced cybersecurity and threat protection systems</p>
            </div>
            <div className='showcase-item'>
              <img
                src='https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
                alt='Cloud Computing'
              />
              <h3>Cloud Infrastructure</h3>
              <p>Scalable cloud solutions for modern enterprises</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className='why-choose-us'>
        <div className='container'>
          <h2 className='section-title'>Why Choose TecMates?</h2>
          <div className='features-grid'>
            <div className='feature'>
              <div className='feature-icon'>
                <i className='fas fa-certificate'></i>
              </div>
              <h3>Certified Professionals</h3>
              <p>
                Our team comprises experienced consultants and certified
                professionals committed to superior service.
              </p>
            </div>

            <div className='feature'>
              <div className='feature-icon'>
                <i className='fas fa-handshake'></i>
              </div>
              <h3>Strategic Partnerships</h3>
              <p>
                Authorized partners of leading global technology brands
                including Acer, HPE, Aruba, and more.
              </p>
            </div>

            <div className='feature'>
              <div className='feature-icon'>
                <i className='fas fa-cogs'></i>
              </div>
              <h3>End-to-End Solutions</h3>
              <p>
                From infrastructure to cloud, we provide comprehensive
                technology solutions under one roof.
              </p>
            </div>

            <div className='feature'>
              <div className='feature-icon'>
                <i className='fas fa-users'></i>
              </div>
              <h3>Customer-Centric</h3>
              <p>
                Grounded in honesty, integrity, and a customer-centric approach
                with cost-effective solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className='partners'>
        <div className='container'>
          <h2 className='section-title'>Our Strategic Partners</h2>
          <p className='section-subtitle'>
            Trusted partnerships with leading global technology brands
          </p>
          <div className='partners-grid'>
            {/* <div className='container'>
              <div className='row'> */}
            {clientList.map((client, index) => (
              <div
                key={index}
                className='bg-white shadow-sm'
                style={{
                  display: 'block',
                  border: '1px solid #ccc',
                  boxShadow: '0px 4px 25px 0px #0000000f;',
                }}
              >
                <Link
                  to='/partners'
                  className='d-block overflow-hidden'
                  style={{ position: 'relative', overflow: 'hidden' }}
                >
                  <center>
                    <img
                      src={client.logo}
                      alt={client.name}
                      style={{ width: '150px', height: '100px' }}
                    />
                  </center>
                </Link>
              </div>
            ))}
            {/* 
              </div>
            </div> */}
            {/* <div className='partner-logo'>Acer</div>
            <div className='partner-logo'>HPE</div>
            <div className='partner-logo'>PeopleLink</div>
            <div className='partner-logo'>Molex</div>
            <div className='partner-logo'>D-Link</div>
            <div className='partner-logo'>Techroutes</div>
            <div className='partner-logo'>Aruba</div>
            <div className='partner-logo'>Systrome</div>
            <div className='partner-logo'>Matrix</div>
            <div className='partner-logo'>Vantageo</div> */}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='cta-section'>
        <div className='container'>
          <h2>Ready to Transform Your IT Infrastructure?</h2>
          <p>
            Let's discuss how TecMates can help accelerate your digital
            transformation journey.
          </p>
          <Link to='/contact' className='btn btn-primary'>
            Get Started Today
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Home
